import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsByClient(clientId) {
        return (await Vue.http.get(`/api/kra/settings/byclient/${clientId}`)).data;
    },
    async save(clientId, settings) {
        await Vue.http.post(`/api/kra/settings/byclient/${clientId}`, settings);
        noty.success("Settings saved successfully");
    },
    async getPaymentsAsync(filter) {
        return (await Vue.http.post("/api/kra/payments", filter)).data;
    },
    async getPaymentAsync(paymentId) {
        return (await Vue.http.get(`/api/kra/payments/${paymentId}`)).data;
    },
    async sendPaymentAsync(paymentId) {
        return (await Vue.http.post(`/api/kra/payments/send/${paymentId}`)).data;
    }
}


// WEBPACK FOOTER //
// ./src/services/kra.service.js